export default class CreateQuoteRenderLoader {
  constructor(element) {
    if (document.querySelector('[data-component="CreateQuote"]')) CreateQuoteRenderLoader.load(element);
  }

  static async load(element) {
    const { default: CreateQuoteRender } = await import(/* webpackChunkName: "CreateQuoteRender" */'../../../render/BookingJourney/CreateQuote');

    new CreateQuoteRender(element);
  }
}
